<template>
  <img class="w-[50%]" ref="imgRef" :src="streamUrl" alt="Flux de la caméra en direct" />
</template>

<script setup>

import {defineProps, onUnmounted, ref} from 'vue';
import constant from "../../../Constant";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const streamUrl = constant.baseUrl + '/imprimantes/stream/' + props.uuid;

const imgRef = ref(null);

onUnmounted(() => {
  if (imgRef.value) {
    imgRef.value.src = '';  // Arrête le téléchargement du flux&#8203;:contentReference[oaicite:3]{index=3}
  }
});

</script>

<style scoped>

</style>